'use client'

import { InfoBanner } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useLocation } from '@marketplace-web/shared/browser-data'
import { KycBannerModel } from '@marketplace-web/banners/banners-data'

import { PAYMENTS_IDENTITY, GO_TO_WALLET_URL } from '../../constants/routes'

type Props = {
  banner: KycBannerModel | undefined
  bottomSpacer?: React.ReactNode
}

const KycBanner = ({ banner, bottomSpacer }: Props) => {
  const translate = useTranslate('kyc_required_banner')
  const { relativeUrl } = useLocation()

  if (!banner) return null

  return (
    <div className={`${relativeUrl === GO_TO_WALLET_URL && 'u-ui-margin-large'}`}>
      <InfoBanner
        body={translate('body')}
        styling={InfoBanner.Styling.Tight}
        type={InfoBanner.Type.Info}
        title={translate('title')}
        actions={[{ text: translate('button'), url: PAYMENTS_IDENTITY }]}
        testId="kyc-banner"
      />
      {bottomSpacer}
    </div>
  )
}

export default KycBanner
